'use client'

import { useEffect, useRef } from 'react'
import { recordAppFreeVhfProgress } from '@/lib/app-data/free-vhf-progress'
import { useAuth } from '@/lib/auth/auth-context'
import { useFreeVhfProgress } from '@/hooks/useFreeVhfProgress'

interface Props {
  scenarioId: string
}

/**
 * Records the current lesson as completed for the signed-in user (upsert).
 * Renders nothing. Call mutate after write so sidebar/My learning refresh.
 */
export default function FreeVhfLessonProgressRecorder({ scenarioId }: Props) {
  const { user } = useAuth()
  const { mutate } = useFreeVhfProgress()
  const recordedRef = useRef(false)

  useEffect(() => {
    if (!user || !scenarioId || recordedRef.current) return
    recordedRef.current = true

    recordAppFreeVhfProgress(scenarioId)
      .then((ok) => {
        if (ok) mutate()
      })
      .catch(() => {
        // Silent — table missing or transient
      })
  }, [user, scenarioId, mutate])

  return null
}
